import NavBar from "../../components/NavBar/NavBar"
import Footer from "../../components/Footer/Footer"
import Title from "../../components/Title/Title"
import CircleCard from "../../components/Circle-Card/Circle-Card"
import Download from "../../components/Download-Button/Download-button"

export default function SevenTimesOF() {
    return (
        <div>
            <NavBar/>
            <Title text={"Devoção aos 7 Pai Nossos de Santa Brígida"}/>                
            <CircleCard imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Paintings/ST_Brigida.jpg"}/>
            
            <Title text={"Sobre estas Orações"}/>
            <p className="info-text">
            Estas 7 orações foram, alegadamente, dadas a Santa Brígida por Jesus, com a instrução de que deveriam ser recitadas diariamente durante doze anos. <br/>
            Crê-se que existem cinco promessas feitas àqueles que completam esta tarefa.<br/>
            As promessas, entretanto, nunca foram confirmadas pela Igreja.
            </p>

        <Title text={"Promessas"}/>
        <p className="info-text">
        O Divino Salvador revelou a Santa Brígida a seguinte promessa:
        “Sabei que darei 5 graças àqueles que, durante 12 anos, rezarem sete Pai Nossos e Ave Marias em honra do meu precioso Sangue:<br/>
        1º) Não terão que passar pelo purgatório. <br/>
        2º) Aceitá-los-ei no Coro dos Mártires como se tivessem derramado seu sangue pela fé.<br/>
        3º) Conservarei 3 almas de seus parentes na graça santificante conforme sua escolha.<br/>
        4º) As almas dos seus parentes até o 4o. grau escaparão do inferno.<br/>
        5º) Um mês antes de sua morte ser-lhes-á dado conhecimento dela. Se por acaso morrerem antes dos 12 anos completos, irei julgar como se fossem as condições cumpridas.”
        </p>

            <Title text={"Como Rezar"}/>                
            <div className="info-text">
            <p><strong>Sinal da Cruz – Oração:</strong> Vinde ESPÍRITO SANTO…!</p>

            Ó Jesus, quero rezar sete vezes o Pai Nosso unindo-me ao amor com que Vós santificastes e dulcificastes esta prece no Vosso Coração. 
            Recebei-os dos meus lábios no Vosso Divino Coração e aperfeiçoai-os, para que dêem tanta honra e alegria à Santíssima Trindade, como Vós quereis que demos na terra. 
            Que esta honra e glória transborde a envolva a Vossa Santíssima Humanidade, para glorificar as Vossas Santas Chagas e o Precioso Sangue que delas brotou.

        <p>
        <strong>1ª Mistério: Circuncisão de Jesus</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço as primeiras chagas, as primeiras dores, e a primeira evasão do preciosíssimo Sangue derramado por JESUS, para expiar os pecados da humanidade, especialmente da juventude, os meus, e para a renúncia aos primeiros pecados, especialmente os mortais, sobretudo da minha família.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>

        <p>
        <strong>2ª Mistério: O Suor de Sangue</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço as dores atrozes do Coração de JESUS no jardim das Oliveiras, e cada gota de Sangue, para expiar todos os pecados do coração de cada pessoa, os meus, para a renúncia a tais pecados e para que aumente o amor a DEUS e ao próximo.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>


        <p>
        <strong>3ª Mistério: Flagelação de Jesus</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço todas as chagas, as dores cruéis, e o Preciosíssimo Sangue de JESUS na flagelação, por todos os pecados da carne, da humanidade, pelos meus, para a renúncia a tais pecados e para a aquisição e conservação da pureza, em especial da minha família.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>

        <p>
        <strong>4ª Mistério: Coroação de Espinhos</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço as chagas, as dores, e o Preciosíssimo Sangue da Sagrada Cabeça de JESUS na coroação de espinhos, para expiar todos os pecados dos pensamentos, da humanidade, os meus, para a renúncia a todos os pecados, e para a extensão do Reino de CRISTO sobre a terra.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>

        <p>
        <strong>5ª Mistério: Caminho da Cruz</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço as dores de JESUS no caminho do calvário, sobretudo na sua santa chaga do ombro, ofereço também o seu preciosíssimo Sangue, para aliviar o peso da Cruz, para reparar os meus murmúrios, para a renúncia a todos os pecados cometidos, e para que haja um verdadeiro amor á Santa Cruz.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>


        <p>
        <strong>6ª Mistério: Crucificação de Jesus</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, eu vos ofereço o vosso Unigênito FILHO cravado na Cruz, as chagas das mãos e dos pés, e os fios de seu Preciosíssimo Sangue derramado por nós, seu extremo aniquilamento, a sua perfeita obediência, e todas as aflições mortais de seu Corpo e Alma. Ofereço-vos a sua preciosa Morte na Cruz que se renova constantemente em cada Santa Missa no Mundo inteiro, para expiar os atentados aos votos e às santas instituições, em reparação dos meus pecados e dos pecados do Mundo inteiro, pelos doentes e moribundos, para obter santos sacerdotes e leigos, pelas intenções do Papa, pela restauração da família cristã, para fortificar e encorajar a Fé, pela nossa Pátria, pela unidade de todos os povos em CRISTO e na vossa Igreja, assim como por todos os Países onde os cristãos estão em minoria.
        <br />
        Amém. Pai nosso … Ave Maria…
        </p>


        <p>
        <strong>7ª Mistério: Abertura do Santo Lado</strong>
        <br />
        Eterno Pai, pelas mãos imaculadas de Maria, aceitai os preciosíssimo dons da Água e do Sangue, que jorraram da chaga do Divino Coração de JESUS, pelas necessidades da Igreja e em expiação dos pecados da humanidade. Sangue propulsado pelo Sacratíssimo Coração de JESUS, lavai-me e purificai-me de todos os meus pecados. Água do Lado de CRISTO, lavai-me e purificai-me de meus primeiros pecados, e salvai-me como a todas as almas das chamas do Purgatório.
        <br />
        Amém. Pai nosso … Ave Maria…
</p>
</div>
        <Title text={"Oração Final"}/>

        <p className="info-text">
            Ó doce Jesus, feri o meu coração a fim de que lágrimas de arrependimento, de compunção e de amor, noite e dia me sirvam de alimento. Convertei-me inteiramente a Vós.  <br/>
            Que o meu coração Vos sirva de perpétua habitação. <br/>
            Que a minha conduta Vos seja agradável e que o fim da minha vida seja de tal modo edificante que eu possa ser admitido(a) no Vosso Paraíso, onde, com os Vossos Santos, Vos hei-de louvar para sempre. <br/>
            Assim seja.  
            Ámen.<br/>
            Em Nome do Pai, do Filho e do Espírito Santo. Ámen.
        </p>       
        <Title text={"Consagração A Nossa Senhora"}/>
        <p className="info-text">
            Ó Santa Mãe Dolorosa de Deus, ó Virgem Dulcíssima, eu Vos ofereço o meu coração a fim de que o conserveis intacto como o Vosso Coração Imaculado. <br/>
            Eu Vos ofereço a minha inteligência, para que ela conceba apenas pensamentos de paz e de bondade, de pureza e verdade. <br/>
            Eu Vos ofereço a minha vontade, para que ela se mantenha viva e generosa ao serviço de Deus. <br/>
            Eu Vos ofereço o meu trabalho, as minhas dores, os meus sofrimentos, as minhas angústias, as minhas tribulações e as minhas lágrimas, no meu presente e no meu futuro, para serem apresentadas por Vós ao Vosso Divino Filho, para purificação da minha vida.<br/>
            Mãe Compassiva, eu me refugio no Vosso Coração Imaculado, para acalmar as dolorosas palpitações das minhas tentações, da minha aridez, da minha indiferença e das minhas negligências.<br/>
            Escutai-me ó Mãe, guiai-me, sustentai-me e defendei-me, contra todos os perigos da alma e do corpo, agora e por toda a eternidade.
            Assim seja! Ámen.
        </p>

        <Download text={"Baixar a Oração"} File={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Downloadable_Files/Fontes_Pascoa.docx"}/>
    <Footer/>
        </div>
    )
}